import React from "react";
import Editor from "./creator/editor";
import Latest from "./creator/latest";
import Banner from "./messenger/banner";
import Freebotdm from "../home/freebotdm";
import Footer from "../shared/footer";
const Messenger = () => {
  return (
    <div>
      <Banner />
      <Editor />
      <Latest />
      <Freebotdm />
      <Footer />
    </div>
  );
};

export default Messenger;
